'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dDanger$002dAlert$0024$0024anon$00244 from "./presto.-Danger-Alert$$anon$4.js";
import * as $j_presto$002e$002dDanger$002dAlert$0024$0024anon$00245 from "./presto.-Danger-Alert$$anon$5.js";
import * as $j_presto$002e$002dDanger$002dAlert$0024$0024anon$00249 from "./presto.-Danger-Alert$$anon$9.js";
var $p;
/** @constructor */
function $c_Lpresto_DangerAlert$$anon$3() {
  this.aJ0 = null;
  this.aIY = null;
  this.aIZ = false;
  this.aIW = null;
  this.aIX = false;
  this.aJ1 = false;
  this.aJ2 = false;
  this.aJ0 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_DangerAlert$$anon$3 as $c_Lpresto_DangerAlert$$anon$3 };
$p = $c_Lpresto_DangerAlert$$anon$3.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_DangerAlert$$anon$3;
/** @constructor */
function $h_Lpresto_DangerAlert$$anon$3() {
}
export { $h_Lpresto_DangerAlert$$anon$3 as $h_Lpresto_DangerAlert$$anon$3 };
$h_Lpresto_DangerAlert$$anon$3.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.af = (function() {
  return this.aJ0;
});
$p.t = (function() {
  if ((!this.aIZ)) {
    this.aIY = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("details", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("application", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("impersonatedBy", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.aIZ = true;
  }
  return this.aIY;
});
$p.ag = (function() {
  if ((!this.aIX)) {
    this.aIW = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002e$002dDanger$002dAlert$0024$0024anon$00244.$c_Lpresto_DangerAlert$$anon$4(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002e$002dDanger$002dAlert$0024$0024anon$00245.$c_Lpresto_DangerAlert$$anon$5(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Encoder$$anon$24(new $j_presto$002e$002dDanger$002dAlert$0024$0024anon$00249.$c_Lpresto_DangerAlert$$anon$9()), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.aIX = true;
  }
  return this.aIW;
});
$p.v = (function() {
  if ((!this.aJ2)) {
    this.aJ1 = false;
    this.aJ2 = true;
  }
  return this.aJ1;
});
$p.ae = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_DangerAlert$$anon$3 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_DangerAlert$$anon$3, "presto.DangerAlert$$anon$3", ({
  Gq: 1,
  a: 1,
  l: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_DangerAlert$$anon$3 as $d_Lpresto_DangerAlert$$anon$3 };
//# sourceMappingURL=presto.-Danger-Alert$$anon$3.js.map
